class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelectorAll('#cart-icon-bubble');

    cartLink.forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink)
        }
      });
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.small = window.matchMedia('(max-width: 750px)');
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.productTitle = parsedState.product_title;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    if (this.small.matches) {
      setTimeout(() => {
        const feedbackHTML = '<div class="feedback-add-product open"><a href="/cart" class="feedback__icon link focus-inset" id="cart-icon-bubble" role="button" aria-haspopup="dialog"><svg class="icon icon-cart" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.486145" y="4.7644" width="17.1091" height="13.1755" fill="currentColor"></rect><path d="M5.56356 5.47837V6.22837H6.19515L6.30262 5.60599L5.56356 5.47837ZM12.5178 5.47837L11.7787 5.60599L11.8862 6.22837H12.5178V5.47837ZM14.0334 5.47837V6.22837H14.8775L14.7782 5.39014L14.0334 5.47837ZM4.04795 5.47837L3.30315 5.39014L3.20385 6.22837H4.04795V5.47837ZM5.63622 6.97837L6.35934 6.7794L6.20772 6.22837H5.63622V6.97837ZM4.09754 6.97837V6.22837H3.19444L3.36029 7.11611L4.09754 6.97837ZM13.9838 6.97837L14.721 7.11611L14.8869 6.22837H13.9838V6.97837ZM12.4451 6.97837V6.22837H11.8736L11.722 6.7794L12.4451 6.97837ZM9.04066 1.83655C6.9235 1.83655 5.16905 3.35528 4.82449 5.35076L6.30262 5.60599C6.52318 4.32862 7.65467 3.33655 9.04066 3.33655V1.83655ZM13.2568 5.35076C12.9123 3.35528 11.1578 1.83655 9.04066 1.83655V3.33655C10.4267 3.33655 11.5581 4.32862 11.7787 5.60599L13.2568 5.35076ZM12.5178 6.22837H14.0334V4.72837H12.5178V6.22837ZM9.04066 1.83655C11.2321 1.83655 13.0399 3.46738 13.2886 5.56661L14.7782 5.39014C14.4394 2.53094 11.9871 0.336548 9.04066 0.336548V1.83655ZM4.79274 5.56661C5.04143 3.46738 6.84926 1.83655 9.04066 1.83655V0.336548C6.09422 0.336548 3.64188 2.53094 3.30315 5.39014L4.79274 5.56661ZM4.04795 6.22837H5.56356V4.72837H4.04795V6.22837ZM5.63622 6.22837H4.09754V7.72837H5.63622V6.22837ZM9.04066 10.2949C6.94665 10.2949 5.2018 8.80519 4.83478 6.84064L3.36029 7.11611C3.85984 9.79004 6.22393 11.7949 9.04066 11.7949V10.2949ZM13.2465 6.84064C12.8795 8.80519 11.1347 10.2949 9.04066 10.2949V11.7949C11.8574 11.7949 14.2215 9.79004 14.721 7.11611L13.2465 6.84064ZM13.9838 6.22837H12.4451V7.72837H13.9838V6.22837ZM9.04066 10.2949C11.0158 10.2949 12.674 8.97355 13.1682 7.17735L11.722 6.7794C11.4047 7.93235 10.3327 8.79488 9.04066 8.79488V10.2949ZM4.91309 7.17735C5.40735 8.97355 7.06553 10.2949 9.04066 10.2949V8.79488C7.74867 8.79488 6.67659 7.93235 6.35934 6.7794L4.91309 7.17735Z" fill="currentColor"></path></svg></a> \
          <span>Has añadido ' + this.productTitle + ' a la <a id="cart-icon-bubble-note" class="feedback__icon link focus-inset" href="/cart">cesta de compra</a></span> \
          <span class="feedback-close"><svg class="icon icon-close" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> \
            <path d="M1.5 1.5L20.0068 20.0068" stroke="currentColor" stroke-width="2" stroke-linecap="square"/> \
            <path d="M20.5 1.5L1.99324 20.0068" stroke="currentColor" stroke-width="2" stroke-linecap="square"/> \
          </svg></span></div>' 
          setTimeout(() => {
            const cartLink = document.getElementById('cart-icon-bubble-note');
              cartLink.addEventListener('click', (event) => {
                event.preventDefault();
                this.open(cartLink)
              });
              cartLink.addEventListener('keydown', (event) => {
                if (event.code.toUpperCase() === 'SPACE') {
                  event.preventDefault();
                  this.open(cartLink)
                }
              });

          }, 100)
        document.body.insertAdjacentHTML('afterbegin', feedbackHTML);
      });
      setTimeout(() => {
        document.querySelector('.feedback-close').addEventListener('click', (event) => {
          document.querySelector('.feedback-add-product').remove(); 
        }); 
      });
      setTimeout(() => {
        if (document.querySelector('.feedback-add-product')) {
          if (document.querySelector('.feedback-add-product').classList.contains('open')) {
            document.querySelector('.feedback-add-product').remove(); 
          }
        }
      }, 5000);
    } else {  
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


/* ==================
   LINKED ADDON SYNC
===================== */

(function() {

  window.cartUpdating = false;
  window.cartThrottle = false;

  const DrawerClass = customElements.get('cart-drawer-items');
  if (!DrawerClass) return;

  const originalUpdateQuantity = DrawerClass.prototype.updateQuantity;

  async function batchUpdate(updates) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }

  async function syncEmptyState() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    drawer.classList.toggle('is-empty', cart.item_count === 0);
  }

  async function refreshDrawer() {
    const res = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
    const text = await res.text();
    const html = new DOMParser().parseFromString(text, 'text/html');
    const source = html.querySelector('cart-drawer');
    document.querySelector('cart-drawer').innerHTML = source.innerHTML;
  }

  async function refreshCartBubble() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Calcular visible_item_count (tu misma lógica Liquid)
    let count = 0;
    cart.items.forEach(item => {
      if (!item.properties || !item.properties._addon) {
        count += item.quantity;
      }
    });

    const bubbleLink = document.getElementById('cart-icon-bubble');
    if (!bubbleLink) return;

    let bubble = bubbleLink.querySelector('.cart-count-bubble');

    // ===== Carrito vacío → quitar bubble =====
    if (count === 0) {
      if (bubble) bubble.remove();
      return;
    }

    // ===== Crear bubble si no existe =====
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubbleLink.appendChild(bubble);
    }

    // ===== Actualizar número =====
    bubble.innerHTML = `
      ${count < 100 ? `<span aria-hidden="true">${count}</span>` : ''}
      <span class="visually-hidden">
        ${window.cartStrings?.cartCount?.replace('[count]', count) || ''}
      </span>
    `;
  }

  DrawerClass.prototype.updateQuantity = async function(line, quantity, name) {

    if (window.cartThrottle) return;
    window.cartThrottle = true;
    setTimeout(() => window.cartThrottle = false, 350);

    if (window.cartUpdating) return;
    window.cartUpdating = true;

    try {

      const row = document.querySelector(`[data-index="${line}"]`);
      if (!row) {
        await originalUpdateQuantity.call(this, line, quantity, name);
        return;
      }

      const bundle = row.dataset.bundle;
      const mainKey = row.dataset.key;

      if (!bundle || !mainKey) {
        await originalUpdateQuantity.call(this, line, quantity, name);
        return;
      }

      const updates = {};

      /* 🗑 eliminar bundle completo */
      if (quantity === 0) {

        const bundleRows = document.querySelectorAll(
          `[data-bundle="${bundle}"]`
        );

        bundleRows.forEach(r => {
          const key = r.dataset.key;
          if (key) updates[key] = 0;
        });

        await batchUpdate(updates);
        await refreshDrawer();
        await syncEmptyState();
        await refreshCartBubble();
        return;
      }

      /* 🔢 cambio normal */
      updates[mainKey] = quantity;

      const addonRows = document.querySelectorAll(
        `[data-bundle="${bundle}"][data-addon="true"]`
      );

      addonRows.forEach(r => {
        const key = r.dataset.key;
        if (key) updates[key] = quantity;
      });

      await batchUpdate(updates);
      await refreshDrawer();
      await refreshCartBubble();

    } catch (err) {
      console.warn('Bundle sync error', err);
    } finally {
      window.cartUpdating = false;
    }

  };

})();